import request from './request'

export function getList(data) {
  return request({
    url: '/web/information/v1/information_page',
    method: 'post',
    data
  })
}
